import styled from 'styled-components'
import React, { useContext } from 'react'
import { useEffect } from 'react'
import { requestTranslation } from '@futures-platform/i18n'
import { Modal, paddingModalStyles } from '@futures-platform/ui'
import { InfoCircle } from '@styled-icons/boxicons-regular'

const InformationModal = ({
  InfoModalOpen,
  InfoModalClose,
  openingFieldEditingModalHandler,
  videoModalClosedHandler,
  isAuthed,
}) => {
  const [isVideoModalOpened, setisVideoModalOpened] = React.useState(false)

  const uA = navigator.userAgent
  const vendor = navigator.vendor
  const isSafari =
    /Safari/i.test(uA) &&
    /Apple Computer/.test(vendor) &&
    !/Mobi|Android/i.test(uA)

  return (
    <Modal
      onRequestClose={InfoModalClose}
      isOpen={InfoModalOpen}
      contentLabel="radar-modal"
      ariaHideApp={false}
      style={paddingModalStyles}>
      <div className="confirmation-modal-content ">
        <div
          className="modal-form-section modal-form-header"
          style={{ padding: '32px', height: '62vh', position: 'relative' }}
          // style={{ marginLeft: '10px' }}
        >
          <div
            style={{
              height: '47.7vh',
            }}>
            <iframe
              allowfullscreen="true"
              sandbox="allow-forms allow-same-origin allow-scripts"
              webkitallowfullscreen
              mozallowfullscreen
              allow="autoplay"
              fullscreen
              frameborder="0"
              width="100%"
              height="100%"
              src={
                !isSafari
                  ? 'https://player.vimeo.com/video/841252367?muted=1&autoplay=1'
                  : 'https://player.vimeo.com/video/841252367?autoplay=1&muted=1'
              }
              title="Futures-Platform spot-light"></iframe>
          </div>
          {!isAuthed && (
            <p
              style={{
                position: 'absolute',
                bottom: '56px',
                color: 'red',
              }}>
              Remember to log in to enable the features!
            </p>
          )}
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              // marginTop: '30px',
              // marginLeft: '65px',
              // marginRight: '12px',
              alignItems: 'center',
              position: 'absolute',
              bottom: '24px',
              width: `calc(100% - 64px)`,
            }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}>
              <input
                onClick={() => {
                  setisVideoModalOpened(() => true)
                  videoModalClosedHandler()
                }}
                type="checkbox"
                style={{
                  // transform: 'scale(1.5)',
                  width: '20px',
                  height: '20px',
                  marginRight: '10px',
                  cursor: 'pointer',
                }}
                checked={isVideoModalOpened}
                id="Formal-academic-or-technical"
              />
              <label
                for="Formal-academic-or-technical"
                style={{
                  // transform: 'scale(1.5)',
                  fontWeight: 'unset',
                  margin: 0,
                }}>
                Don't show this again
              </label>
            </div>
            {!openingFieldEditingModalHandler && (
              <button
                className="btn btn-primary btn-lg btn-primary"
                onClick={InfoModalClose}>
                OK
              </button>
            )}
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default InformationModal

const InformationIcon = styled(InfoCircle)`
  background-color: white;
  color: #00c3ff;
  width: 45px;
  height: 45px;
`
const InformationUl = styled.ul`
  width: '72%';
`
const InformationLi = styled.li`
  line-height: 1.4
  margin-top: 8px;
  margin-bottom: 8px;
`

const InformationLink = styled.button`
  color: #006998;
  &:hover {
    cursor: pointer;
  }
`
